import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Paper, Typography } from '@mui/material';
import { subscribeToDownloads } from '../utils/downloadIndicator';

export default function DownloadIndicator() {
  const [activeDownloads, setActiveDownloads] = useState(0);

  useEffect(() => subscribeToDownloads(setActiveDownloads), []);

  if (!activeDownloads) return null;

  return (
    <Paper
      role="status"
      aria-live="polite"
      sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 2000, p: 2, boxShadow: 6 }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <CircularProgress size={20} aria-label="Download in progress" />
        <Typography variant="body2">
          {activeDownloads === 1 ? 'Preparing download…' : `Preparing ${activeDownloads} downloads…`}
        </Typography>
      </Box>
    </Paper>
  );
}
